import React from 'react';

import Image from '../../../../library/image/image';
import Typography from '../../../../library/typography/typography';
import AngleRightLightIcon from '../../../../shared/icons/angle-right-light-icon';
import ScheduleAppointmentButton from '../../../schedule-appointment-button/schedule-appointment-button';

import './need-assistance.scss';

function NeedAssistance() {
  return (
    <aside className="need-assistance" styleName="container">
      <Image
        alt="Make appoinment"
        className="need-assistance__feature-image"
        src="https://discounttire.scene7.com/is/image/discounttire/discount-tire-customer-and-employee-talking-register-area-US19357"
        styleName="feature-image"
      />
      <div className="need-assistance__content" styleName="content">
        <Typography weight="bold">Need assistance?</Typography>
        <Typography size="small" styleName="description">
          Visit any {window.siteName} store to speak with a trusted expert. We
          are always ready and willing to help!
        </Typography>
      </div>
      <div
        className="display-sm need-assistance__divider"
        styleName="divider"
      />
      <ScheduleAppointmentButton
        className="appointment-button"
        isSecondary={false}
      >
        make an appointment <AngleRightLightIcon />
      </ScheduleAppointmentButton>
    </aside>
  );
}

export default NeedAssistance;
